module.exports = __webpack_public_path__ + "static/img/map.3b4716f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/map.png
// module id = amov
// module chunks = 0